import React from "react";
import styles from "./index.module.scss";

export function ModalHeader() {
    return (
        <div className={styles.root}>
            <div className={styles.title}>下载全部视频</div>

            <div className={styles.tip}>
                注意：该功能仅支持下载往期在白果上发起的直播回放的视频，在课程内容页面上传的本地视频是不在此下载视频范围内的，且请务必在
                <b>30</b>
                天内完成下载，<b>30</b> 天后下载链接将失效且不可恢复。
            </div>
        </div>
    );
}
